import { Injectable, inject } from '@angular/core';
import { DfEventData, DfEventService } from '@df/core/service/df-event';
import { GtmDataService } from '@df/module-gtm/service/gtm-data.service';
import { GtmDlService } from '@df/module-gtm/service/gtm-dl.service';
import './gtm-event-begin-checkout';

@Injectable({
    providedIn: 'root'
})
export class GtmEventBeginCheckoutTrigger {
    /**
     * GTM service
     */
    private gtmService = inject(GtmDlService);

    /**
     * DF events service
     */
    private dfEventService = inject(DfEventService);

    /**
     * GTM basket service
     */
    private gtmDataService = inject(GtmDataService);

    /**
     * Setup event listener
     */
    constructor() {
        this.init();
    }

    /**
     * Setup event listener
     */
    private init() {
        this.dfEventService.success(event => {
            if (event.id === 'dfCheckoutBegin') {
                this.dispatch(event);
            }
        });
    }

    /**
     * Dispatch event
     */
    private async dispatch(trigger: DfEventData) {
        return this.gtmService.dispatch({
            event: 'begin_checkout',
            triggerContext: {
                trigger
            },
            ecommerce: await this.gtmDataService.getEventData(this.gtmDataService.getBasketItems(), this.gtmDataService.getBasketExtras())
        });
    }
}
